import PlaceholderPage from '@/pages/placeholder/page';

export default function TimelinePage() {
  return (
    <PlaceholderPage
      title="Timeline công việc"
      icon="ri-timeline-view"
      description="Theo dõi tiến độ công việc theo phòng ban: nhóm việc, trạng thái, deadline, người phụ trách và thảo luận."
      phase={5}
    />
  );
}